import { all, either, equals, isNil, omit, propOr, values } from 'ramda';
import { attachedToEnum } from '@@viewEnums';
import { ControlledInput, ControlledSSInput } from '@@viewCommonComponents/controlled';
import { Button, Message } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import { isRequiredInput } from '@@viewHelpers/validations';

const SSInputByAttachedTo = ({
  attachedToValue,
  getFieldsName,
  form,
  getMiddleText,
  setDisplayReferentModal,
  currentReferent,
  isDisplayed = true
}) => {
  if (!isDisplayed) {
    return null;
  }

  const isEmptyReferent = all(
    isNil,
    values(omit(['__typename'], currentReferent))
  );
  const spouseIdx = propOr([], 'grantees', form.getValues()).findIndex(
    (g) => g.type === 'SPOUSE'
  );
  return (
    <>
      {(equals(attachedToValue, attachedToEnum.ADHERENT_PRINCIPAL) ||
        equals(
          attachedToValue,
          attachedToEnum.ADHERENT_PRINCIPAL_ET_CONJOINT
        ) ||
        equals(
          attachedToValue,
          attachedToEnum.ADHERENT_PRINCIPAL_ET_AUTRE
        )) && (
        <ControlledSSInput
          label={getMiddleText('MEMBER_SS_LABEL')}
          SSInputName={'customer.socialSecurities.0.number'}
          birthDateInputName={'customer.birthDate'}
          disabled
          form={form}
          data-testid="MEMBER_SS"
        />
      )}

      {either(
        equals(attachedToEnum.CONJOINT),
        equals(attachedToEnum.ADHERENT_PRINCIPAL_ET_CONJOINT)
      )(attachedToValue) && (
        <ControlledSSInput
          label={getMiddleText('MEMBER_SS_LABEL')}
          SSInputName={`grantees.${spouseIdx}.socialSecurities.0.number`}
          birthDateInputName={`grantees.${spouseIdx}.birthDate`}
          disabled
          form={form}
          data-testid="MEMBER_SS"
        />
      )}

      {either(isNil, equals(attachedToEnum.EN_NOM_PROPRE))(attachedToValue) && (
        <ControlledSSInput
          label={getMiddleText('MEMBER_SS_LABEL')}
          SSInputName={getFieldsName('socialSecurities.0.number')}
          birthDateInputName={getFieldsName('birthDate')}
          form={form}
          data-testid="MEMBER_SS"
        />
      )}

      {either(
        equals(attachedToEnum.AUTRE),
        equals(attachedToEnum.ADHERENT_PRINCIPAL_ET_AUTRE)
      )(attachedToValue) && (
        <div className={'grid grid-cols-1 md:grid-cols-3! gap-2 w-full'}>
          <ControlledInput
            name={getFieldsName('attachedSocialSecurities.0.referent')}
            containerClassName={'grid col-span-1 md:col-span-2'}
            form={form}
            label={getMiddleText('MEMBER_REFERENT_LABEL')}
            disabled
            withIndicator={false}
            rules={isRequiredInput()}
            data-testid="MEMBER_REFERENT"
          />
          <Button
            className={'col-span-1 '}
            onClick={() => setDisplayReferentModal(true)}
            data-testid="REFERENT_BUTTON"
          >
            {isEmptyReferent
              ? getMiddleText('ADD_REFERENT_BUTTON')
              : getMiddleText('UPDATE_REFERENT_BUTTON')}
          </Button>
          <Message
            variant="error"
            label={getErrorMessage(
              form.formState.errors,
              getFieldsName('attachedSocialSecurities.0')
            )}
          />
        </div>
      )}
    </>
  );
};

export default SSInputByAttachedTo;
